<template>
    <componentType :item="item" class="task-item" />
</template>
<script setup>
import AuditAnalyticsEntityDiscoveredTaskItem from './AuditAnalyticsEntityDiscovered.vue'
import JobEndedTaskItemWrapper from '@/components/manage/tasks/JobEnded/JobEndedTaskItemWrapper'
import JobsTaskItem from './Jobs/'
import ProviderEntityTaskItem from './ProviderEntityTaskItem'
import ProviderIdentificationUpdatedTaskItem from './provider-identification-updated-task-item.vue'
import SecCompensationTaskItem from './SecCompensationTaskItem.vue'
import SecMatchingTaskItem from './SecMatchingTaskItem.vue'
import SecOwnershipTaskItem from './SecOwnershipTaskItem.vue'
import UnknownTaskItem from './unknown-task-item.vue'
import { computed } from 'vue'

const props = defineProps({
    item: {
        type: Object,
        required: true,
    },
})

const components = {
    'Audit Analytics Entity Discovered': AuditAnalyticsEntityDiscoveredTaskItem,
    Jobs: JobsTaskItem,
    'Job Ended': JobEndedTaskItemWrapper,
    'Provider Entities': ProviderEntityTaskItem,
    'Provider Identification Updated': ProviderIdentificationUpdatedTaskItem,
    'SEC Compensation': SecCompensationTaskItem,
    'SEC Matching': SecMatchingTaskItem,
    'SEC Ownership': SecOwnershipTaskItem,
}

const componentType = computed(() => {
    return components[props.item.category] ?? UnknownTaskItem
})
</script>
<style>
.task-item {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    justify-content: space-between;
}

.task-item .task-body {
    padding: 0 8px;
    flex-grow: 1;
    overflow: auto;
}

.task-item .task-actions {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    width: 100%;
    padding: 8px 16px;
    gap: 16px;

    background-color: var(--color-primary-100);
}

.task-item dl {
    align-items: center;
    display: grid;
    grid-template-columns: 2fr 3fr;
    grid-auto-rows: 40px;
}

.task-item dl dt {
    font-weight: bold;
}

.task-item .task-body {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.task-body h2 {
    margin-top: 16px;
}
</style>
